import { ReactNode, RefObject, useEffect, useMemo, useState } from 'react';
import { animated, SpringValue } from 'react-spring';

import { getRandomArrayOfBackgroundImages } from './images';
import {
  getBackgroundImageRotateTransform,
  getBackgroundImageScaleTransform,
  getBackgroundImageXPosition,
  getBackgroundImageYPosition,
  getRandomBackgroundImageTransform,
} from './helper';
import { BACKGROUND_IMAGES } from './constants';
import { useStyles } from './styles';

interface Props {
  readonly containerRef: RefObject<HTMLDivElement>;
  readonly mouseCoords: SpringValue<number[]>;
}

const Background = ({ containerRef, mouseCoords }: Props) => {
  const [backgroundImagesComponents, setBackgroundImagesComponents] = useState<
    ReactNode[]
  >([]);

  const classes = useStyles();

  const backgroundImages = useMemo(
    () => getRandomArrayOfBackgroundImages(BACKGROUND_IMAGES.COUNT),
    []
  );

  useEffect(() => {
    const backgroundComponents = backgroundImages.map(
      (backgroundImage, index) => {
        const containerHeight = containerRef.current?.offsetHeight || 0;

        const scaleTransformValue = getBackgroundImageScaleTransform();
        const rotateTransformValue = getBackgroundImageRotateTransform();
        const randomX = getBackgroundImageXPosition();
        const randomY = getBackgroundImageYPosition(containerHeight);
        const blurValue = 1 / scaleTransformValue - 0.5;

        return (
          <animated.img
            key={`${backgroundImage}-${index}`}
            src={backgroundImage}
            style={{
              position: 'absolute',
              width: BACKGROUND_IMAGES.MAX_SIZE,
              filter: `blur(${blurValue}px)`,
              opacity: scaleTransformValue,
              transform: mouseCoords.to(
                getRandomBackgroundImageTransform(
                  randomX,
                  randomY,
                  scaleTransformValue,
                  rotateTransformValue
                ) as any
              ),
              zIndex: -1,
            }}
          />
        );
      }
    );
    setBackgroundImagesComponents(backgroundComponents);
  }, [backgroundImages, containerRef, mouseCoords]);

  return (
    <div className={classes.backgroundParallax}>
      {backgroundImagesComponents}
    </div>
  );
};

export default Background;
